import { api } from '@/shared/api/api';

import { type ShareData } from './types';

export const getShareMessageId = async (data: ShareData) => {
  return api.post<string>('v1/share', data).then((res) => res.data);
};
